import { InMemoryCache, IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import { ApolloLink } from "apollo-link";
import { onError } from "apollo-link-error";
import { PrismicLink } from "apollo-link-prismic";
import introspectionQueryResultData from "./getSchema/prismic-gql-schema.json";
var graphqlApiEndpoint = process.env.PRISMIC_API_URI;
var onErrorLink = onError(function (_ref) {
  var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError;

  if (graphQLErrors) {
    graphQLErrors.map(function (_ref2) {
      var message = _ref2.message,
          locations = _ref2.locations,
          path = _ref2.path;
      return console.error("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
    });
  }

  if (networkError) {
    console.error("[Network error]: ".concat(networkError));

    if ("result" in networkError) {
      var _networkError$result;

      console.error("message:", networkError === null || networkError === void 0 ? void 0 : (_networkError$result = networkError.result) === null || _networkError$result === void 0 ? void 0 : _networkError$result.message);
    }
  }
});
var prismicLink = PrismicLink({
  uri: graphqlApiEndpoint
});
var link = ApolloLink.from([onErrorLink, prismicLink]);
var fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: introspectionQueryResultData
});
export var prismicApolloClient = new ApolloClient({
  cache: new InMemoryCache({
    fragmentMatcher: fragmentMatcher
  }),
  link: link
});
export var linkResolver = function linkResolver(linkable) {
  if (linkable && "url" in linkable) {
    return linkable.url || "";
  }

  if (linkable && "_meta" in linkable && linkable._meta.type === "blog_post" && linkable._meta.uid) {
    return "/blog/".concat(linkable._meta.uid);
  }

  if (linkable && "_meta" in linkable && linkable._meta.uid) {
    return "/".concat(linkable._meta.uid);
  }

  return "";
};